import { render, staticRenderFns } from "./SubpasosReceta.vue?vue&type=template&id=b8ee25aa&scoped=true&"
import script from "./SubpasosReceta.vue?vue&type=script&lang=js&"
export * from "./SubpasosReceta.vue?vue&type=script&lang=js&"
import style0 from "./SubpasosReceta.vue?vue&type=style&index=0&id=b8ee25aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ee25aa",
  null
  
)

export default component.exports